/* Omaggio alberi di Natale EDG — Prestige Home
 *
 * Due compiti distinti:
 * 1. il BOX sotto il prezzo, solo sulle schede abilitate (CFG.attivo)
 * 2. la MANUTENZIONE del carrello, ovunque: aggancia l'omaggio agli alberi che
 *    non ce l'hanno, allinea le quantità e toglie quelli rimasti orfani
 *
 * L'OMAGGIO SEGUE IL CARRELLO, NON LA SCHEDA (27 ottobre 2026). Prima il regalo
 * veniva agganciato solo quando l'albero partiva dal form della scheda prodotto:
 * chi aggiungeva dalla collezione, dalla ricerca o dai consigliati restava senza,
 * e senza che nessuno se ne accorgesse. Ora lo script riconosce gli alberi idonei
 * leggendo il carrello (fornitore, tipo prodotto e identificativo arrivano da
 * CFG) e aggancia l'omaggio predefinito a chi non ce l'ha.
 *
 * IL RIFIUTO È ESPLICITO. "Non desidero l'omaggio" e il cestino sulla riga del
 * regalo scrivono un attributo del carrello (ATTR_RIFIUTO), che finisce
 * nell'ordine: così "nessun omaggio" si distingue da "non gliel'hanno mai
 * chiesto", cosa che prima era impossibile sapere. L'attributo tiene gli
 * identificativi degli alberi rifiutati, viene ripulito da solo quando quegli
 * alberi non sono più nel carrello, e sparisce se il cliente cambia idea.
 *
 * Le opzioni arrivano da CFG.opzioni, che il Liquid costruisce leggendo le
 * varianti del prodotto "Omaggio Albero di Natale". Aggiungere un omaggio è
 * quindi una variante nuova in admin, non una modifica qui dentro.
 *
 * Qui restano solo le due cose che il titolo della variante non può dire:
 * DESCRIZIONI (a cosa serve quella misura) e CAMPI (gli omaggi che chiedono
 * anche qualcosa per iscritto: palline e prodotto a scelta). Il testo di ciascuna
 * resta suo: cambiare opzione non cancella quanto scritto.
 *
 * Sempre una sola opzione attiva, e il predefinito è CFG.predefinita. Ricliccare
 * l'opzione scelta la conferma, non la libera.
 *
 * Un omaggio per ogni albero: tre alberi uguali fanno tre omaggi.
 */
(function () {
  'use strict';

  var CFG = window.omaggioConfig;
  if (!CFG || !CFG.opzioni || !CFG.opzioni.length) return;

  var NESSUNO = '__nessuno__';
  var ATTR_RIFIUTO = 'Omaggio rifiutato';
  var ESCLUSI = CFG.esclusi || [];
  var FORNITORE = CFG.fornitore || 'EDG';
  var TIPO = CFG.tipo || 'Alberi di Natale';

  // A cosa serve quella misura: il titolo della variante non lo dice.
  var DESCRIZIONI = {
    'OMAGGIO-BORSONE-120': 'Per alberi fino a 210 cm',
    'OMAGGIO-BORSONE-150': 'Per alberi fino a 270 cm'
  };

  // Gli omaggi che chiedono anche qualcosa per iscritto.
  var CAMPI = {
    'OMAGGIO-PALLINE': {
      segnaposto: 'Modello preferito — lascia vuoto e scegliamo noi',
      etichetta: 'Modello preferito',
      seVuoto: 'Nessuna preferenza, scegliamo noi'
    }
  };
  CAMPI[CFG.skuLibera] = {
    segnaposto: 'Inserisci il codice o il titolo del prodotto che desideri',
    etichetta: 'Prodotto richiesto',
    seVuoto: 'Da concordare con il cliente'
  };

  // L'opzione libera va in fondo, dopo gli omaggi concreti.
  var OPZIONI = CFG.opzioni.slice().sort(function (a, b) {
    if (a.sku === CFG.skuLibera) return 1;
    if (b.sku === CFG.skuLibera) return -1;
    return 0;
  });

  var predefinita = OPZIONI.filter(function (o) { return o.sku === CFG.predefinita; })[0];
  var scelta = predefinita ? predefinita.sku : OPZIONI[0].sku;

  var testi = {};
  var inAttesa = null;
  var occupato = false;
  var falliti = {};

  var ICONA_REGALO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var ICONA_SPUNTA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function opzioneScelta() {
    return OPZIONI.filter(function (o) { return o.sku === scelta; })[0] || null;
  }

  function conOmaggio() {
    return scelta !== NESSUNO;
  }

  function testoDi(sku) {
    return testi[sku] || '';
  }

  /* ------------------------------------------------------------------ utils */

  function routes() {
    var r = (window.theme && window.theme.routes) || {};
    return {
      cartJs: (r.cart || '/cart') + '.js',
      add: r.cartAdd || '/cart/add.js',
      change: r.cartChange || '/cart/change.js',
      update: r.cartUpdate || '/cart/update.js'
    };
  }

  async function getCart() {
    var res = await fetch(routes().cartJs, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js ' + res.status);
    return res.json();
  }

  async function post(url, body) {
    var res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) throw new Error(data.description || data.message || url + ' ' + res.status);
    return data;
  }

  async function ridisegnaCarrello() {
    var el = document.querySelector('.cc-main-cart cart-items') || document.querySelector('cart-items');
    if (el && typeof el.refresh === 'function') {
      try { await el.refresh(); } catch (e) { /* non bloccante */ }
    }
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ------------------------------------------------- alberi idonei e rifiuti */

  /* Un albero ha diritto all'omaggio per quello che è, non per come è entrato
     nel carrello: stesse condizioni del box (fornitore, tipo, non escluso). */
  function albero(riga) {
    if (!riga || (riga.properties || {})._omaggio) return false;
    if (riga.vendor !== FORNITORE) return false;
    if (riga.product_type !== TIPO) return false;
    return ESCLUSI.indexOf(String(riga.product_id)) === -1;
  }

  function rifiutiDi(cart) {
    var valore = (cart.attributes || {})[ATTR_RIFIUTO] || '';
    return String(valore).match(/\d{6,}/g) || [];
  }

  function valoreRifiuti(lista) {
    return lista.length ? 'Sì (' + lista.join(', ') + ')' : '';
  }

  async function scriviAttributi(nuovi) {
    var cart = await getCart();
    var attuali = cart.attributes || {};
    var uniti = {};
    Object.keys(attuali).forEach(function (k) { uniti[k] = attuali[k]; });
    // Vuoto, non assente: è l'unico modo per cui Shopify cancella davvero.
    Object.keys(nuovi).forEach(function (k) { uniti[k] = nuovi[k] == null ? '' : nuovi[k]; });
    return post(routes().update, { attributes: uniti });
  }

  async function segnaRifiuto(variantId) {
    var cart = await getCart();
    var lista = rifiutiDi(cart);
    var id = String(variantId);
    if (lista.indexOf(id) !== -1) return false;
    lista.push(id);
    var attrs = {};
    attrs[ATTR_RIFIUTO] = valoreRifiuti(lista);
    await scriviAttributi(attrs);
    return true;
  }

  async function togliRifiuto(variantId) {
    var cart = await getCart();
    var lista = rifiutiDi(cart);
    var id = String(variantId);
    if (lista.indexOf(id) === -1) return false;
    lista = lista.filter(function (x) { return x !== id; });
    var attrs = {};
    attrs[ATTR_RIFIUTO] = valoreRifiuti(lista);
    await scriviAttributi(attrs);
    return true;
  }

  /* -------------------------------------------------------------- il box */

  function rigaHTML(sku, nome, descrizione, valore, foto, segnaposto, semplice) {
    return '<label class="omaggio__opt' + (semplice ? ' omaggio__opt--plain' : '') + '" data-opt="' + esc(sku) + '">' +
             '<span class="omaggio__row">' +
               '<input type="checkbox" class="omaggio__input js-omaggio-opt" value="' + esc(sku) + '">' +
               '<span class="omaggio__box">' + ICONA_SPUNTA + '</span>' +
               (foto || '') +
               '<span class="omaggio__text">' +
                 '<span class="omaggio__name">' + esc(nome) + '</span>' +
                 (descrizione ? '<span class="omaggio__desc">' + esc(descrizione) + '</span>' : '') +
                 (valore
                   ? '<span class="omaggio__value">' +
                       '<span class="omaggio__was">' + esc(valore) + '</span>' +
                       '<span class="omaggio__free">in regalo</span>' +
                     '</span>'
                   : '') +
               '</span>' +
             '</span>' +
             (segnaposto
               ? '<span class="omaggio__field" hidden>' +
                   '<input type="text" class="js-omaggio-testo" maxlength="120" autocomplete="off" ' +
                   'placeholder="' + esc(segnaposto) + '">' +
                 '</span>'
               : '') +
           '</label>';
  }

  function miniatura(o, libera) {
    if (!libera && o.immagine) {
      return '<img class="omaggio__thumb" src="' + esc(o.immagine) + '" alt="" width="40" height="40" loading="lazy">';
    }
    return '<span class="omaggio__thumb omaggio__thumb--vuota">' + ICONA_REGALO + '</span>';
  }

  function creaBox() {
    var righe = OPZIONI.map(function (o) {
      var libera = o.sku === CFG.skuLibera;
      var campo = CAMPI[o.sku];

      return rigaHTML(
        o.sku,
        libera ? 'Un altro prodotto a tua scelta' : o.titolo,
        libera ? '' : DESCRIZIONI[o.sku],
        o.valore,
        miniatura(o, libera),
        campo ? campo.segnaposto : '',
        false
      );
    }).join('');

    righe += rigaHTML(NESSUNO, 'Non desidero l’omaggio', '', '', '', '', true);

    var box = document.createElement('div');
    box.className = 'omaggio';
    box.innerHTML =
      '<div class="omaggio__head">' + ICONA_REGALO +
        '<span class="omaggio__eyebrow">In regalo con questo albero</span>' +
      '</div>' +
      '<p class="omaggio__title">Scegli il tuo omaggio fino a ' + esc(CFG.valoreMassimo) + '</p>' +
      (CFG.nota ? '<p class="omaggio__nota">' + ICONA_SPUNTA + '<span>' + esc(CFG.nota) + '</span></p>' : '') +
      '<div class="omaggio__list">' + righe + '</div>' +
      '<p class="omaggio__confirm">' + ICONA_SPUNTA +
        '<span>Un omaggio per ogni albero, lo aggiungiamo al carrello insieme a lui.</span>' +
      '</p>';
    return box;
  }

  /* Il blocco prezzo, saltando i blocchi delle app che gli stanno attaccati
     (per esempio l'avviso del prezzo più basso negli ultimi 30 giorni, che per
     legge deve restare accanto al prezzo). */
  function trovaAncora() {
    var blocchi = [].slice.call(document.querySelectorAll('.product-info__block'));
    var prezzo = null;

    for (var i = 0; i < blocchi.length; i += 1) {
      if (blocchi[i].querySelector('.price__current') && !blocchi[i].querySelector('[name="add"]')) {
        prezzo = blocchi[i];
        break;
      }
    }
    if (!prezzo) return null;

    var ancora = prezzo;
    var dopo = ancora.nextElementSibling;
    while (dopo && dopo.classList && dopo.classList.contains('product-info__block') &&
           dopo.querySelector('[id^="shopify-block"]')) {
      ancora = dopo;
      dopo = ancora.nextElementSibling;
    }
    return ancora;
  }

  function monta() {
    if (!CFG.attivo) return;
    if (document.querySelector('.omaggio')) return;
    var ancora = trovaAncora();
    if (!ancora) return;
    ancora.insertAdjacentElement('afterend', creaBox());
    applicaStato();
  }

  function applicaStato() {
    var box = document.querySelector('.omaggio');
    if (!box) return;

    box.classList.toggle('is-active', conOmaggio());

    box.querySelectorAll('.omaggio__opt').forEach(function (opt) {
      var sku = opt.dataset.opt;
      var mio = sku === scelta;

      opt.querySelector('.js-omaggio-opt').checked = mio;
      opt.classList.toggle('is-selected', mio);

      var campo = opt.querySelector('.omaggio__field');
      if (!campo) return;
      campo.hidden = !mio;

      var input = campo.querySelector('.js-omaggio-testo');
      if (input && input.value !== testoDi(sku)) input.value = testoDi(sku);
    });
  }

  /* ---------------------------------------------------------------- eventi */

  document.addEventListener('change', function (evt) {
    var t = evt.target;
    if (!t || !t.matches || !t.matches('.js-omaggio-opt')) return;

    scelta = t.value;
    applicaStato();

    var input = document.querySelector('.omaggio__opt[data-opt="' + scelta + '"] .js-omaggio-testo');
    if (input) input.focus();
  });

  document.addEventListener('input', function (evt) {
    var t = evt.target;
    if (!t || !t.matches || !t.matches('.js-omaggio-testo')) return;
    var opt = t.closest('.omaggio__opt');
    if (!opt) return;
    testi[opt.dataset.opt] = t.value;
  });

  // Il click nel campo di testo non deve rimbalzare sulla label e cambiare scelta.
  document.addEventListener('click', function (evt) {
    if (evt.target && evt.target.matches && evt.target.matches('.js-omaggio-testo')) {
      evt.preventDefault();
      evt.target.focus();
    }
  });

  /* Il cestino sulla riga dell'omaggio non è una cancellazione qualunque: è una
     rinuncia, e come tale va scritta, altrimenti la manutenzione del carrello
     rimetterebbe il regalo un istante dopo. */
  document.addEventListener('click', function (evt) {
    var b = evt.target.closest ? evt.target.closest('.js-omaggio-rifiuta') : null;
    if (!b) return;
    evt.preventDefault();
    evt.stopPropagation();
    if (occupato) return;
    occupato = true;
    b.disabled = true;

    var chiave = b.getAttribute('data-key');
    var bersaglio = b.getAttribute('data-albero');

    Promise.resolve()
      .then(function () { return segnaRifiuto(bersaglio); })
      .then(function () { return post(routes().change, { id: chiave, quantity: 0 }); })
      .then(function () { return ridisegnaCarrello(); })
      .catch(function (e) { console.error('[omaggio]', e); b.disabled = false; })
      .then(function () { occupato = false; });
  }, true);

  // Annoto quale albero sta partendo, e con quale scelta. Niente preventDefault:
  // il form prosegue e la confezione regalo resta libera di fare il suo lavoro.
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.classList || !form.classList.contains('js-product-form')) return;
    if (!CFG.attivo) return;

    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;

    if (!conOmaggio()) {
      inAttesa = { variantId: Number(id.value), rifiuto: true };
      return;
    }

    var opt = opzioneScelta();
    if (!opt) return;

    inAttesa = {
      variantId: Number(id.value),
      titolo: CFG.prodotto,
      omaggio: opt,
      testo: testoDi(opt.sku).trim()
    };
  });

  async function applicaScelta() {
    if (!inAttesa) return false;
    var dati = inAttesa;
    inAttesa = null;

    if (dati.rifiuto) {
      return segnaRifiuto(dati.variantId);
    }

    var cart = await getCart();

    var gia = cart.items.filter(function (i) {
      return (i.properties || {})._omaggio === String(dati.variantId);
    })[0];

    await togliRifiuto(dati.variantId);
    if (gia) return true; // c'è già: ci pensa sistemaCarrello() alla quantità

    var riga = cart.items.filter(function (i) {
      return i.variant_id === dati.variantId && !(i.properties || {})._omaggio;
    })[0];
    if (!riga) return false;

    var props = {
      _omaggio: String(dati.variantId),
      Per: dati.titolo || riga.product_title
    };

    var campo = CAMPI[dati.omaggio.sku];
    if (campo) props[campo.etichetta] = dati.testo || campo.seVuoto;

    await post(routes().add, {
      items: [{ id: dati.omaggio.id, quantity: riga.quantity, properties: props }]
    });

    return true;
  }

  /* Manutenzione del carrello, su qualsiasi pagina:
     · aggancia l'omaggio predefinito agli alberi idonei che non ce l'hanno e che
       non è stato rifiutato (è la parte che recupera chi ha aggiunto l'albero
       dalla collezione, dalla ricerca o dai consigliati)
     · allinea le quantità: tre alberi, tre omaggi
     · toglie gli omaggi rimasti senza il loro albero e i doppioni
     · ripulisce i rifiuti di alberi non più nel carrello */
  async function sistemaCarrello() {
    var cart = await getCart();
    var rifiuti = rifiutiDi(cart);

    var quantita = {};
    var alberi = {};
    var conRegalo = {};

    cart.items.forEach(function (i) {
      var bersaglio = (i.properties || {})._omaggio;
      if (bersaglio) { conRegalo[bersaglio] = true; return; }
      var k = String(i.variant_id);
      quantita[k] = (quantita[k] || 0) + i.quantity;
      if (albero(i)) alberi[k] = i;
    });

    var daFare = [];
    var visti = {};

    cart.items.forEach(function (i) {
      var bersaglio = (i.properties || {})._omaggio;
      if (!bersaglio) return;

      var atteso = quantita[bersaglio] || 0;

      if (!atteso || visti[bersaglio]) {
        daFare.push({ id: i.key, quantity: 0 });
        return;
      }

      visti[bersaglio] = true;
      if (i.quantity !== atteso) daFare.push({ id: i.key, quantity: atteso });
    });

    var cambiato = false;

    for (var k = 0; k < daFare.length; k += 1) {
      await post(routes().change, daFare[k]);
      cambiato = true;
    }

    var pre = OPZIONI.filter(function (o) { return o.sku === CFG.predefinita; })[0] || OPZIONI[0];
    var chiavi = Object.keys(alberi);

    for (var j = 0; j < chiavi.length; j += 1) {
      var chiave = chiavi[j];
      if (conRegalo[chiave] || rifiuti.indexOf(chiave) !== -1 || falliti[chiave]) continue;

      var riga = alberi[chiave];
      var props = { _omaggio: chiave, Per: riga.product_title };
      var campo = CAMPI[pre.sku];
      if (campo) props[campo.etichetta] = campo.seVuoto;

      try {
        await post(routes().add, {
          items: [{ id: pre.id, quantity: riga.quantity, properties: props }]
        });
        cambiato = true;
      } catch (e) {
        // Omaggio non disponibile: non si riprova a ogni modifica del carrello.
        falliti[chiave] = true;
        console.error('[omaggio]', e);
      }
    }

    var restano = rifiuti.filter(function (id) { return !!alberi[id]; });
    if (restano.length !== rifiuti.length) {
      var attrs = {};
      attrs[ATTR_RIFIUTO] = valoreRifiuti(restano);
      await scriviAttributi(attrs);
      cambiato = true;
    }

    return cambiato;
  }

  async function sincronizza() {
    if (occupato) return;
    occupato = true;
    try {
      var scelto = await applicaScelta();
      var sistemato = await sistemaCarrello();
      if (scelto || sistemato) await ridisegnaCarrello();
    } catch (e) {
      console.error('[omaggio]', e);
    } finally {
      occupato = false;
    }
  }

  document.addEventListener('on:cart:add', function () { setTimeout(sincronizza, 400); });
  document.addEventListener('on:line-item:change', function () { setTimeout(sincronizza, 400); });

  function avvio() {
    monta();
    sincronizza();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvio);
  } else {
    avvio();
  }

  document.addEventListener('shopify:section:load', monta);

  var timer = null;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(monta, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();